import { createAsyncThunk } from '@reduxjs/toolkit';
import { activeSnack } from '../store/common';
import { post, get } from './http';

export const createBooking = createAsyncThunk(
  '/inspection-booking/new',
  async ({ state, dispatch, reset, navigate, selectedBrandId }) => {
    try {
      const URL = `/inspection-booking/new`;
      const response = await post(URL, state);
      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Submitted successfully' }));

        if (navigate) {
          if (response?._id) {
            // navigate('/pay-latter-success', { state: { state } });
            navigate(`/pay-latter-success/${response?._id}`);
          } else {
            navigate('/pay-latter-fail', { state: { selectedBrandId } });
          }
        }

        if (state?.payment_type === 'ONLINE') {
          localStorage.setItem('bookingInfo', JSON.stringify(response));

          await dispatch(
            createRazorpayOrder({
              dispatch,
              type: state?.type,
              typeId: response?._id,
            })
          );
        }
        if (reset) {
          reset();
        }
        return response;
      }
      return response;
      // return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const createChallan = createAsyncThunk('/Challan /new', async ({ state, dispatch }) => {
  try {
    const URL = `/challan/new`;
    const response = await post(URL, state);
    if (response) {
      dispatch(activeSnack({ type: 'success', message: 'Submitted successfully' }));

      // if (navigate) {
      //   navigate('/success-page', { state: { state } });
      // }

      localStorage.setItem('challanInfo', JSON.stringify(response));

      await dispatch(
        createRazorpayOrder({
          dispatch,
          type: state?.type,
          typeId: response?._id,
        })
      );
      return response;
    }
    return response;
    // return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
export const createRazorpayOrder = createAsyncThunk(
  'course-purchase/razorpay-order',
  async ({ dispatch, typeId, type }) => {
    try {
      const URL = `/payment/v2/razorpay`;
      const response = await post(URL, { type, typeId });

      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Payment initiated' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getChallanDetails = createAsyncThunk('challan/single', async ({ challanId, dispatch }) => {
  try {
    const response = await get(`/challan/${challanId}`);
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
export const inspectionDocumentVerify = createAsyncThunk(
  '/inspection-document/verify',
  async ({ state, dispatch, reset, navigate }) => {
    try {
      const URL = `inspection-document/verification`;
      const response = await post(URL, state);
      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Submitted successfully' }));

        if (navigate) {
          navigate(`/pdf-view/${response?.inspection_data?.inspection_number}`, { state });
        }
        if (reset) {
          reset();
        }
        return response;
      }
      return response;
      // return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getInspectionBookingDetails = createAsyncThunk('booking/single', async ({ bookingId, dispatch }) => {
  try {
    const response = await get(`/inspection-booking/${bookingId}`);
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
export const getInspectionDocumentDetails = createAsyncThunk('document/single', async ({ documentId, dispatch }) => {
  try {
    const response = await get(`/inspection-document/${documentId}`);
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
